import { defineStore } from "pinia";
export const useGlobalAlertStore = defineStore("nuxt-spoferan-global-alert", {
  state: () => ({
    isVisible: false,
    props: {},
    listeners: {}
  }),
  actions: {
    showAlert(options) {
      return new Promise((resolve) => {
        this.isVisible = true;
        this.props = options;
        this.listeners = {
          hide: () => {
            this.isVisible = false;
            this.props = {};
            this.listeners = {};
          },
          confirm: (inputData) => {
            resolve({ confirmed: true, data: inputData });
          },
          cancel: () => {
            resolve({ confirmed: false });
          }
        };
      });
    },
    showConfirm(options) {
      return this.showAlert({ ...options, confirm: true, cancel: true });
    }
  }
});
